// extracted by mini-css-extract-plugin
export var arrow = "_3h-6";
export var changeItem = "_3h-3";
export var changesHeader = "_3h-1";
export var changesList = "_3h-2";
export var container = "_3h-0";
export var pathLabel = "_3h-4";
export var value = "_3h-7";
export var valuesContainer = "_3h-5";